export default class DiscountStatusStepDTO {
    key: string;

    isCompleted: boolean;

    label: string;

    link: string;

    additionalData: {
        spent_amount: number;
        has_verified_documents: boolean;
        shops_id: number[];
    };

    constructor({
        Key = '',
        IsCompleted = false,
        Link = '',
        Label = '',
        AdditionalData = {
            spent_amount: 0,
            has_verified_documents: false,
            shops_id: []
        }
    }: {
        Key?: string;
        IsCompleted?: boolean;
        Link?: string;
        Label?: string;
        AdditionalData?: {
            spent_amount: number;
            has_verified_documents: boolean;
            shops_id: number[];
        };
    } = {}) {
        this.key = Key;
        this.isCompleted = IsCompleted;
        this.label = Label;
        this.link = Link;
        this.additionalData = AdditionalData;
    }
}
